import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function CreateImage(image) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/images', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({image: image})
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function GetImage(imageId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/admin/images/' + imageId, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch images.' },
      { status: 500 }
    ));
  }

  const resData = await response.json();
  return resData.data;
}

export async function ListImages(page, skip_pagination) {
  const token = getAuthToken()

  if (token === null) {
    return { data: [], pagination: {} }
  }

  let queryParams = []
  if (page) {
    queryParams.push("page=" + page)
  }
  if (skip_pagination) {
    queryParams.push("skip_pagination=1")
  }

  const url = config.apiBaseUrl + `/rest/admin/images` + (queryParams.length > 0 ? `?${queryParams.join("&")}` : '')
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch images.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function DeleteImage(imageId) {
  const response = await fetch(config.apiBaseUrl + `/rest/admin/images/${imageId}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (!response.ok) {
    return false;
  } else {
    return true;
  }
}
